<template>
  <span class="radial-hover-secondary d-flex icon-wrapper" :id="icon + '-' + uuid">
    <i class="icon-element" :class="icon" @click="$emit('click', $event)"></i>
    <tooltip :target="icon + '-' + uuid" v-if="tooltipText">{{ tooltipText }}</tooltip>
  </span>
</template>

<script>
import Tooltip from '@/components/Tooltip.vue'
import ComponentIdMixin from '@/mixins/ComponentIdMixin'

/**
 * This gives a round-edged icon. Icon can be modified through prop. It emits a click event
 */
export default {
  name: 'ActionIcon',
  mixins: [ComponentIdMixin],
  props: {
    tooltipText: String,
    icon: {
      type: String,
      default: 'plus-icon'
    }
  },
  components: { Tooltip },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/hoverStates';
.icon-element {
  padding: 8px;
  background-position: center;
  cursor: pointer;
}
.icon-wrapper {
  padding: 2px;
}
.icon-wrapper,
.icon-element {
  border-radius: 4px;
}
</style>
